import AppTemplate from '@components/v2/layout/AppTemplate/AppTemplate';
import { useEffect } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import LoadingPage from '../../../components/LoadingPage/LoadingPage';
import SecureRoute from '../../../lib/SecureRoute';
import {
  ApplicationContextProvider,
  useApplicationContext,
} from '../../../modules/context/ApplicationContext/ApplicationContext';
import { useHandleHydrateOfflineDatabase } from '../../../modules/offline/database/hooks/useHandleHydrateOfflineDatabase';
import { useAutoOfflineDataUpdate } from '../../../modules/offline/hooks/useAutoOfflineDataUpdate/useAutoOfflineDataUpdate';
import useOrderBook from '../../../modules/order-book/hooks/useOrderBook';
import { FeatureVisibilityProvider } from '../../../modules/permissions/contexts/FeatureVisibilityContext';
import ProductDetailsPanel from '../../../modules/products/products-details-v2/components/ProductDetailsPanel/ProductDetailsPanel';
import ProductDetailsUrlSync from '../../../modules/products/products-details-v2/components/ProductDetailsUrlSync/ProductDetailsUrlSync';
import { getOfflineHomeRoutes } from '../../offlineHome.routes';
import PATHS from '../../routes.const';
import { useHomeNavItems } from '../hooks/useHomeNavItems';
import OfflineNavigationHeader from './components/OfflineNavigationHeader';
import OfflineNavigationSidebarBottom from './components/OfflineNavigationSidebarBottom';
import OfflineUserMenu from './components/OfflineUserMenu/OfflineUserMenu';

const OfflineHome = () => {
  const { state, userRole, team } = useApplicationContext();
  const { initializeOrderBookStore } = useOrderBook({ isOfflineMode: true });
  const { navItems } = useHomeNavItems();

  useAutoOfflineDataUpdate();
  useHandleHydrateOfflineDatabase();

  useEffect(() => {
    if (team?.id) {
      initializeOrderBookStore();
    }
  }, [team?.id, state.user]);

  if (state.isLoadingBrands || !userRole) {
    return <LoadingPage />;
  }

  return (
    <>
      <ProductDetailsUrlSync />

      <AppTemplate
        navItems={navItems}
        collapsedMode="hidden"
        slots={{
          header: <OfflineNavigationHeader />,
          bottomBar: <OfflineUserMenu />,
          sidebarBottom: <OfflineNavigationSidebarBottom />,
          workspaceOverlay: <ProductDetailsPanel isOfflineMode />,
        }}
      >
        <Switch>
          {getOfflineHomeRoutes().map((route) => (
            <SecureRoute {...route} key={route.path} />
          ))}

          <Redirect to={PATHS.offline.catalogs.path} />
        </Switch>
      </AppTemplate>
    </>
  );
};

const OfflineHomeNavigation = () => (
  <ApplicationContextProvider isOfflineMode>
    <FeatureVisibilityProvider isOfflineMode>
      <OfflineHome />
    </FeatureVisibilityProvider>
  </ApplicationContextProvider>
);

export default OfflineHomeNavigation;
